module.exports = __webpack_public_path__ + "img/main_bg.a587e2a6.png";